export default __webpack_public_path__ + "static/media/srikant-story.78c6ec79.png";